import ColorPicker from "../picker/ColorPicker";
import CommonStyleEditor from "./CommonStyleEditor";

export default function TextCellProperties({ cell, onChange }) {

    const cell_type = cell.type;

    return(
        <div className="property-section">
            <div className="property-section-title">Texte</div>
            <div className="property-row">
                <textarea className="property-input property-input-small" value={cell.text || ''} onChange={(e) => onChange(cell.cell_id, {text: e.target.value, type: cell_type})} rows={6} cols={30}/>
            </div>

            <div className="property-section-title">Styles</div>
            <div className="property-row">
                <div className="property-label">Couleur de texte</div>
                <ColorPicker value={cell.styles_properties?.text_color || '#000000'} onChange={(color) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, text_color: color}, type: cell_type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Taille de la police</div>
                <input className="property-input property-input-small" type="number" value={cell.styles_properties?.font_size || 16} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, font_size: parseInt(e.target.value)}, type: cell_type})}/>
            </div>

            <div className="property-section-title">Alignement</div>
            <div className="property-row">
                <div className="property-label">Alignement horizontal</div>
                <select className="property-input property-input-small" value={cell.styles_properties?.text_align || 'left'} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, text_align: e.target.value}, type: cell_type})}>
                    <option value="left">Gauche</option>
                    <option value="center">Centre</option>
                    <option value="right">Droite</option>
                </select>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    )
}